import React from "react";
import { useSelector } from "react-redux";

import { Avatar, Divider, ListItem } from "@material-ui/core";
import { menuOptionsStyles } from "./MenuOption.styles";
import { RootState } from "../../../store";
import { Participant } from "../../../models/api/participant";

interface ProfileOptionProps {
  setScreen: (screen: string[]) => void;
}

export const ProfileOption = (props: ProfileOptionProps) => {
  const { setScreen } = props;
  const classes = menuOptionsStyles();
  const participantProfile = useSelector<RootState, Participant>(
    (state) => state.profile
  );

  const onClick = () => setScreen(["profile"]);

  return (
    <>
      <Divider />
      <ListItem className={classes.menuLink} onClick={onClick}>
        <ListItem component="div" className={classes.menuOption}>
          <Avatar
            className={classes.avatar}
            src={participantProfile?.profilePicturePath}
          />
          <span>Financial Profile</span>
        </ListItem>
      </ListItem>
      <Divider />
    </>
  );
};
